import {
  ActionIcon,
  Button,
  Group,
  NumberFormatter,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconBuildingStore, IconEdit, IconFolder } from "@tabler/icons-react";
import { useState } from "react";
import { editPool } from "../../../../api/EmailAPI";
import { editFolder } from "../../../../api/FolderAPI";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useNavigate, useParams } from "react-router-dom";
import PopOver from "../../../../components/View/PopOver";

const CommunityItem = ({
  item,
  type,
  setOpened,
  setLoading,
  getClickLink,
  getDeletedLink,
}) => {
  const { resellerId } = useParams();

  const navigate = useNavigate();
  const handleClick = (newFolder) => {
    navigate(getClickLink(newFolder.id));
    setOpened(false);
  };

  const onDeleted = () => {
    if (parseInt(resellerId) === item.id) {
      navigate(getDeletedLink());
    }
    setOpened(false);
  };

  const onEdited = () => {
    setLoading(true);
  };

  return (
    <Button
      component="div"
      mih={48}
      key={item.id}
      variant={resellerId === item.id.toString() ? "filled" : "subtle"}
      leftSection={<IconBuildingStore size={18} />}
      onClick={(e) => {
        e.stopPropagation();
        handleClick(item);
      }}
      justify="start"
    >
      {item.name}

      <Group
        pos={"absolute"}
        right={16}
        gap={"xs"}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Text>
          <NumberFormatter value={item.number_of_users} />
        </Text>
        {/* <RenameFolder item={item} type={type} onEdited={onEdited} /> */}
      </Group>
    </Button>
  );
};

const RenameFolder = ({ item, type, onEdited }) => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);

  const handleSubmit = (e, handleClose) => {
    e.preventDefault();

    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    const main = type ? editPool : editFolder;
    main({ name: data.name, id: item.id })
      .then(() => {
        onEdited?.();
        handleClose?.();
      })
      .finally(() => setLoading(false));
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Tooltip label={lang.components.folder_navigator.edit_title} withArrow>
          <ActionIcon
            variant="white"
            onClick={(e) => {
              e.preventDefault();
              handleOpen(e);
            }}
            ref={ref}
            disabled
          >
            <IconEdit size={16} />
          </ActionIcon>
        </Tooltip>
      )}
      popoverChildren={(handleClose) => (
        <Stack
          component={"form"}
          onSubmit={(e) => handleSubmit(e, handleClose)}
          w={200}
          gap={0}
        >
          {/* <TextInput
            label={
              isPool
                ? lang.pools.create.dialog.name
                : lang.components.folder_navigator.create.name
            }
            placeholder={
              isPool
                ? lang.pools.create.dialog.name
                : lang.components.folder_navigator.create.name
            }
            defaultValue={item.name}
            name="name"
            data-autoFocus
            required
          /> */}

          <Group justify="end">
            <Button
              loading={loading}
              variant="light"
              type="submit"
              w={"100%"}
              mt={"xs"}
            >
              {lang.components.folder_navigator.edit_title}
            </Button>
          </Group>
        </Stack>
      )}
    />
  );
};

export default CommunityItem;
